/**
 * URLs da API e midia — definidas em build time (Vite).
 *
 * Local:     VITE_API_URL=/api  (proxy Vite -> Django)
 * Railway:   VITE_API_URL=https://SEU-BACKEND.up.railway.app/api
 */
function readEnv(name: string, fallback = ""): string {
  const value = import.meta.env[name];
  if (typeof value === "string" && value.trim()) {
    return value.trim().replace(/\/$/, "");
  }
  return fallback;
}

/** Base da API REST (sem barra final). Ex.: https://apieusebionews.up.railway.app/api */
export const API_BASE_URL = readEnv("VITE_API_URL", "/api");

/** Origem da API (sem /api). Ex.: https://apieusebionews.up.railway.app */
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "") || "";

/** Base para arquivos de midia. Vazio = mesma origem do portal. */
export const MEDIA_BASE_URL = readEnv("VITE_MEDIA_URL", API_ORIGIN);
